<template>
  <div class="contact">
    <div class="banner">
      <img src="../../static/img/lxwm_banner@2x.png" alt="">
    </div>
    <ul class="adds_cont">
      <li v-for="(item,i) in contactAdd" :key="i">
        <img :src="item.conpanyImg" alt="">
        <div class="xxdz">
            <h4 class="compAdd">{{item.companyAdd}}</h4>
            <h4 class="compAdds">北京飞猪科技有限公司</h4>
            <p>
                <span>地址:</span>
                <span>{{item.companyAdds}}</span>
            </p>
            <p>
              <span>电话:</span>
              <span>{{item.companyPhone}}</span>
            </p>

        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      contactAdd: [
        {
          companyAdd: '北京总部',
          conpanyImg: require('../../static/img/北京总部背景@2x.png'),
          companyAdds: '北京市延庆区延庆经济开发区百泉街10号3栋186-8室',
          companyPhone: '400-665-0265'
        },
        {
          companyAdd: '上海分部',
          conpanyImg: require('../../static/img/上海分部背景@2x.png'),
          companyAdds: '上海市浦东新区宁桥路909号',
          companyPhone: '400-665-0265'
        },
        {
          companyAdd: '山东分部',
          conpanyImg: require('../../static/img/山东分部背景@2x.png'),
          companyAdds: '山东省潍坊市坊子区凤凰街168号',
          companyPhone: '400-665-0265'
        },{
          companyAdd: '成都分部',
          conpanyImg: require('../../static/img/成都分部背景@2x.png'),
          companyAdds: '成都高新区益州大道中段722号',
          companyPhone: '400-665-0265'
        }
      ]
    };
  },
  mounted () {
    if(this.isMobile()) {
          this.$router.push({ path: "/contact" });
        } else {
          this.$router.push({ path: "/lxwm?page=6" });
        }
  },
   methods: {
    // lxwm?page=6
    isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  }
};
</script>
<style lang="scss" scoped>
.cent {
  margin: 0 auto;
  width: 92%;
}
.banner {
  width: 100%;
  height: 3.4rem;
  img {
    width: 100%;
    height: 100%;
  }
}
.adds_cont{
  li{
    border-bottom: .1rem solid #fef8f6;
    position: relative;
    height: 2.82rem;
    img{
      display: block;
      width: 100%;
      height: 100%;
    }
    .xxdz{
      position: absolute;
      top: 0.2rem;
      left: .3rem;
      right: 0;
      h4{
        font-size: .28rem;
      }
      .compAdd{
        color: #165297;
        font-weight: 600;
        height: .5rem;
        line-height: .5rem;
        border-bottom: 1px solid #024ea2;
      }
      .compAdds{
        color: #363636;
        padding:.3rem 0 .2rem 0;
      }
      p{
        font-size: .26rem;
        width: 6.3rem;
        color: #707171;
        display: flex;
        justify-content: flex-start;
        span:nth-child(1){
          width: .8rem;
          display: inline-block;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue